import { Alert } from "react-bootstrap"
import { useTranslation } from 'react-i18next';

const MissingAccountRecordTypeAlert = ({ accountId }: { accountId: string }) => {
    const { t } = useTranslation()

    return (
        <Alert variant='danger'>
            {t('account_cannot_create_opportunity')}
            <br />
            {t('please_add_type_record')}
             &nbsp;

            {process.env.REACT_APP_SALESFORCE_INSTANCE_URL ? (
                <a target={'_blank'}
                    href={process.env.REACT_APP_SALESFORCE_INSTANCE_URL + `/lightning/r/Account/${accountId}/view`}
                >{t('on_saleforce')}</a>
            ): t('on_saleforce')}
        </Alert>
    )
}

export default MissingAccountRecordTypeAlert;